import React, { useState } from 'react';
import { Menu, MenuItem } from '@material-ui/core';
import { MOVE_TO_LABEL } from '../constants';
import { CardLinkButton } from './blocks';

/**
 * "Move to" button and menu on a board card, for moving it without dragging (keyboard and touch). The card's
 * current place is listed but disabled.
 *
 * @param {{ targets: Array<{ key: string|null, label: string }>, currentKey: string|null, onMove: (toKey: string|null) => void, cardName: string, disabled?: boolean }} props
 *   `targets` come from `moveTargets`. `cardName` names the card for screen readers, for example "line 2, CHR-DIN-OAK".
 */
export const MoveToMenu = ({ targets, currentKey, onMove, cardName, disabled = false }) => {
    const [anchor, setAnchor] = useState(null);
    const close = () => setAnchor(null);
    return (
        <>
            <CardLinkButton
                component="button"
                type="button"
                aria-haspopup="true"
                aria-label={`${MOVE_TO_LABEL}: ${cardName}`}
                disabled={disabled}
                onClick={(event) => setAnchor(event.currentTarget)}
            >
                {MOVE_TO_LABEL} ▾
            </CardLinkButton>
            <Menu anchorEl={anchor} keepMounted={false} open={Boolean(anchor)} onClose={close}>
                {targets.map((target) => (
                    <MenuItem
                        key={target.key ?? 'tray'}
                        disabled={target.key === currentKey}
                        onClick={() => {
                            close();
                            onMove(target.key);
                        }}
                    >
                        {target.label}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};

export default MoveToMenu;
